import React,{useState} from 'react'
import { IoMdArrowDropdown, IoMdArrowDropup} from 'react-icons/io';
import Select from './Select'
import {allSelect} from '../../data/Data'
const ActionTop = () => {
const [showDropdown,setShowDropdown] = useState(false)
const [selected,setSeleceted] = useState("")
  return (
    <div className="top-action">
      <div className="top-action-left">
        {
        allSelect?.map((data,i)=>
          <Select data={data} key={i} />)
        }
      </div>
      <div className="top-action-right">
          <div className="action-dropdown-content">
          <div className='action-dropdown-btn' onClick={()=>setShowDropdown(!showDropdown)}>
            <span>Sort by Popularity {selected+1}</span> 
            <div className='action-dropdown-icons'>
              <IoMdArrowDropup/> <IoMdArrowDropdown/>
            </div>
          </div>
            <ul className={`action-dropdown ${showDropdown ? "show-dropdown":" "}`}  onMouseLeave={()=> setShowDropdown(false)}>
              {
                Array.from({length:5}).map((_,i)=><li onClick={()=>{
                  setShowDropdown(!showDropdown)
                  setSeleceted(i)
                }} key={i}>Sort by Popularity {i+1}</li>)
              }
            </ul>
          </div>
      </div>
    </div>
  );
}

export default ActionTop
